import { render, staticRenderFns } from "./FileThumbPreview.vue?vue&type=template&id=0c073400&scoped=true"
import script from "./FileThumbPreview.vue?vue&type=script&lang=js"
export * from "./FileThumbPreview.vue?vue&type=script&lang=js"
import style0 from "./FileThumbPreview.vue?vue&type=style&index=0&id=0c073400&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c073400",
  null
  
)

export default component.exports